import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { LandingPageRoutingModule } from '@landing-page/landing-page-routing.module'
import { LandingPageComponent } from '@landing-page/landing-page.component'
import { LandingPageBookingComponent } from '@landing-page/sections/booking/landing-page-booking.component'
import { LandingPageDemoRequestComponent } from '@landing-page/sections/demo-request/landing-page-demo-request.component'
import { LandingPageFAQComponent } from '@landing-page/sections/faq/landing-page-faq.component'
import { LandingPageFleetManagementComponent } from '@landing-page/sections/fleet-management/landing-page-fleet-management.component'
import { LandingPageMissionComponent } from '@landing-page/sections/mission/landing-page-mission.component'
import { LandingPagePartnersComponent } from '@landing-page/sections/partners/landing-page-partners.component'
import { LandingPageQuotesModule } from '@landing-page/sections/quotes/landing-page-quotes.module'
import { LandingPageFooterComponent } from '@platform-lib/components/footer/landing-page-footer/landing-page-footer.component'
import { LandingPageTopBarComponent } from '@platform-lib/components/header/landing-page-top-bar/landing-page-top-bar.component'
import { LandingPageWagonTrackingComponent } from '@landing-page/sections/wagon-tracking/wagon-tracking.component'
import { LandingPageCurveModule } from './components/curve/landing-page-curve.module'
import { LandingPageHeroShotComponent } from './sections/hero-shot/landing-page-hero-shot.component'
import { LandingPagePlanningComponent } from './sections/planning/landing-page-planning.component'

@NgModule({
    declarations: [LandingPageComponent],
    imports: [
        CommonModule,
        LandingPageBookingComponent,
        LandingPageCurveModule,
        LandingPageDemoRequestComponent,
        LandingPageFAQComponent,
        LandingPageFleetManagementComponent,
        LandingPageFooterComponent,
        LandingPageHeroShotComponent,
        LandingPageMissionComponent,
        LandingPagePartnersComponent,
        LandingPagePlanningComponent,
        LandingPageQuotesModule,
        LandingPageRoutingModule,
        LandingPageTopBarComponent,
        LandingPageWagonTrackingComponent,
    ],
})
export class LandingPageModule {}
